import { useTranslation } from "react-i18next";
import { ConfirmationModal } from "src/components/Modals/ConfirmationModals/ConfirmationModal";

interface RegenerateDiscussionConfirmationModalProps {
	onClose: () => void;
	onConfirm: () => Promise<void> | void;
}

export const RegenerateDiscussionConfirmationModal = ({
	onClose,
	onConfirm,
}: RegenerateDiscussionConfirmationModalProps) => {
	const { t } = useTranslation();

	const handleConfirm = async () => {
		await onConfirm();
	};

	return (
		<ConfirmationModal
			title={t(
				"modals.confirm.regenerateDiscussion.title",
				"Czy na pewno chcesz przegenerować omówienie?",
			)}
			onConfirm={handleConfirm}
			onClose={onClose}
		>
			<p className="m-0 text-center">
				{t(
					"modals.confirm.regenerateDiscussion.subtitle",
					"Obecne omówienie zostanie trwale usunięte, a w jego miejsce wygenerujemy nowe od zera. Tej akcji nie da się cofnąć.",
				)}
			</p>
		</ConfirmationModal>
	);
};
